/**
 * Deep links into the Help Center. Prefer these over the Help Center homepage
 * so support questions land on the relevant article.
 *
 * Content lives on help.rivetai.com - always go through HELP_ORIGIN here
 * rather than hardcoding the hostname elsewhere (see BUG-04: a couple of
 * call sites hardcoded the bare, non-resolving "help.rivetai.com" instead of
 * "www.help.rivetai.com", which is the host that's actually live).
 *
 * BUG-04: none of the article slugs below are published in the Help Center
 * yet (they all 404), so every key currently falls back to the Help Center
 * home (HELP_ORIGIN) instead of a dead deep link. Once an article ships,
 * give that key its real path back, e.g.
 * `budgetActuals: ${HELP_ORIGIN}/en/articles/entering-budget-actuals`.
 */
const HELP_ORIGIN = "https://www.help.rivetai.com";

export const helpArticleUrls = {
  home: HELP_ORIGIN,
  billing: HELP_ORIGIN,
  budgetHealthMetrics: HELP_ORIGIN,
  budgetActuals: HELP_ORIGIN,
  budgetCollaboration: HELP_ORIGIN,
  budgetLockEstimate: HELP_ORIGIN,
  budgetFringes: HELP_ORIGIN,
  budgetScenarios: HELP_ORIGIN,
  scheduleShootDays: HELP_ORIGIN,
  aiCreditsPlans: HELP_ORIGIN,
} as const;

export type HelpArticleKey = keyof typeof helpArticleUrls;
